import React from 'react';
import { Button } from '@wds/button';

import useTrackingDetails from '~pricing/hooks/useTrackingDetails';

import useCta from '~pricing/hooks/useCta';
import { generateCTAMetricsAttribute } from '~pricing/pages/shared/index';
import { PackageIds } from '~shared/constants/pricing';
import { PackageCTAProps } from '~pricing/components/PackageCta/types';

import useStyles from '~pricing/components/PackageCta/useStyles';
import { usePricingState } from '~shared/hooks/usePricingState';

const PackageCta = ({ packageName, isSummaryPage = false, className = '' }: PackageCTAProps): JSX.Element => {
  const {
    state: {
      packages: { getPackageById },
    },
  } = usePricingState();

  const { CTA, noCTA } = useStyles({ packageName });
  const packageId = PackageIds[packageName];
  const { pageName } = useTrackingDetails();
  const { isEnabled, ctaUrl, ctaLabel } = useCta(getPackageById(packageId));

  return (
    <div className={`${className} ${isEnabled ? CTA : noCTA}`}>
      <Button
        data-sm-metrics={generateCTAMetricsAttribute({
          pageName,
          packageId: `${packageId}`,
          packageName, // lowercase canonical_name
        })}
        href={ctaUrl}
        variant={isEnabled ? 'solid' : 'text'}
        disabled={!isEnabled}
        data-testid="PackageCta__Btn"
        size={isSummaryPage ? 'md' : 'sm'}
      >
        {ctaLabel}
      </Button>
    </div>
  );
};

export default PackageCta;
